export default __webpack_public_path__ + "static/media/kausi5-min.0090bec9.jpg";